//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    totalPages: {
      type: Number,
      default: 1
    },
    currentPage: {
      type: Number,
      required: true
    }
  },
  mounted() {
    this.$refs.paginationModalContent.scrollLeft = (this.currentPage - 1) * 60
  },
  methods: {
    close (...args) {
      this.$emit('close', ...args)
    },
    getCurrentUrl(page) {
      if (page === 1) {
        const query = {...this.$route.query}
        if (query.pageNum) {
          delete query.pageNum
        }
        return {
          path: this.$route.path,
          query
        }
      }
      return {
        path: this.$route.path,
        query: {
          ...this.$route.query,
          pageNum: page
        }
      }
    }
  }
}
